import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, tap } from 'rxjs';

import { MasterDetailDependencyService } from './master-detail-dependency.service';

export abstract class MasterDependencyResolver<TMaster, TDetail> {
    constructor(
        protected dependencyService: MasterDetailDependencyService<TMaster, TDetail>,
        private router: Router,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TMaster | undefined> {
        return this.dependencyService.getContext(route).pipe(
            tap((result) => {
                if (this.dependencyService.shouldRedirect()) {
                    const childRoute = this.getChildRoute(route, state, result);
                    this.router.navigate([childRoute]);
                }
            }),
        );
    }

    preResolve(route: ActivatedRouteSnapshot): void {
        this.dependencyService.getPreResolvedDetailData(route);
    }

    abstract getChildRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, result?: TMaster): string;
}
